<template>
  <div>
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        検出
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">検出</a>
          </li>
      </ul>
    </div>
    <vcl-facebook v-if="loading"></vcl-facebook>
    <div v-else class="animated fadeIn" id="detect_detail">
      <b-row>
        <b-col v-if="thumbnail_size == '100%'" lg="7">
          <b-card class="text-center">
            <div slot="header">
              <strong class="float-left">検出内容</strong>
              <small class="float-right" v-if="!add && model.detected_at">検査開始時間 : ({{model.detected_at | datetime}})</small>
            </div>
            <b-row>
              <b-col md="12">
                <b-form-group>
                  <b-button link block variant="light" @click="copy(model.task_key, 'ticket')" id="tooltip-target-1">
                    <h4> チケット : {{model.task_key}} </h4>
                  </b-button>
                  <b-tooltip target="tooltip-target-1" triggers="hover">
                    FQDNを押すことでチケットをコピーすることができます。サイトに問題がある場合、迅速に処理するためにチケットに連絡する必要があります
                  </b-tooltip>
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <!-- <b-col md="2"></b-col> -->
              <b-col>
                <b-row>
                  <b-col>
                      <b-form-group>
                      <label for="ph_username" v-b-tooltip.hover>名前</label><br>
                      <label for="ph_domain">{{model && model.site && model.site.name || '現在のデータはありません'}}</label>
                    </b-form-group>
                  </b-col>
                </b-row>
                <hr>
                <b-row>
                  <b-col>
                    <b-form-group>
                      <label for="ph_domain" v-b-tooltip.hover>ドメインを確認</label><br>
                      <label for="ph_domain">{{model.domain}}</label>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col md="3">
                <b-form-group>
                  <label v-b-tooltip.hover title="パターンの危険度を示します">
                    レベル
                    <span>
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </label>
                  <br>
                  <b-badge variant="danger" v-if="codes.WMDS_LEVEL(model.level, 'EN') == 'high'"> {{codes.WMDS_LEVEL(model.level, "EN")}}</b-badge>
                  <b-badge variant="primary" v-else> {{codes.WMDS_LEVEL(model.level, "EN")}}</b-badge>
                </b-form-group>
              </b-col>

              <b-col :md="model && codes.WMDS_TYPE[model.type] == 'MD5' || codes.WMDS_TYPE[model.type] == 'Regex' ? 4 : 3">
                <label v-b-tooltip.hover title="パターンの種類を説明します">
                  検出タイプ
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <p v-if="model && model.type">{{codes.WMDS_TYPE[model.type]}}</p>
              </b-col>
              <b-col :md="model && codes.WMDS_TYPE[model.type] == 'MD5' || codes.WMDS_TYPE[model.type] == 'Regex' ? 4 : 3">
                <label v-b-tooltip.hover title="検出されたページが通過したサイト リンクの数を示します。">
                  深度
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <p v-if="model && model.type">{{depth}}</p>
              </b-col>
              <b-col v-if="model && codes.WMDS_TYPE[model.type] != 'MD5' && codes.WMDS_TYPE[model.type] != 'Regex'" md="3">
                <!-- URL, String -->
                <label v-if="codes.WMDS_TYPE[model.type] == 'URL'" v-b-tooltip.hover title="サイト上でパターンが検出された行を表示します。 この行は、サイトの動的読み込みが完了した行番号です。">
                  Line
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <p v-if="model && codes.WMDS_TYPE[model.type] == 'URL'">{{row_id + 1 || '-'}}</p>

                <!-- MD5 -->
                <!-- <p v-if="model && codes.WMDS_TYPE[model.type] == 'MD5'">{{row_id + 1 || '-'}}</p> -->

                <!-- Regex -->
                <!-- <label v-if="codes.WMDS_TYPE[model.type] == 'Regex'" v-b-tooltip.hover title="正規表現で一致した数値を表示します">
                  매칭 개수
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <p v-if="model && codes.WMDS_TYPE[model.type] == 'Regex'">{{row_count || '-'}}</p> -->
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col md="12">
                <table class="table table-sm table-dark">
                  <thead>
                    <tr>
                      <th scope="col">整合性検証の方法</th>
                      <th scope="col">値</th>
                      <th scope="col">概要</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in ([{ type : 'MD5', value : model.md5, desc : 'ページのURLが検出されました' }, { type : 'URL HASH', value : model.url_hash, desc : '検出されたページURL ハッシュ' }] || [])" :key="index">
                      <th scope="row">{{row.type}}</th>
                      <th scope="row">{{row.value}}</th>
                      <th scope="row">{{row.desc ? row.desc : '-'}}</th>
                    </tr>
                  </tbody>
                </table>
              </b-col>
              <!-- <b-col md="6">
                <b-form-group>
                  <label for="ph_count" v-b-tooltip.hover>ハッシュ</label><br>
                  <label for="ph_ext" v-if="model && model.detail_data">{{model.url_hash}}</label>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label for="ph_count" v-b-tooltip.hover>MD5</label><br>
                  <label for="ph_ext" v-if="model && model.detail_data">{{model.md5}}</label>
                </b-form-group>
              </b-col> -->
            </b-row>
            <hr>
            <b-row>
              <b-col md="12">
                <h3>
                  <p for="ph_count" v-b-tooltip.hover>検出パターン</p>
                  <span v-if="model.data && (model.f1code || model.ucode)">{{model.f1code || model.ucode}}</span>
                </h3>
              </b-col>
            </b-row>
            <hr>
            <b-button size="sm" variant="danger" class="float-left" @click="confirm = true"> 削除 </b-button>
            <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> 一覧 </b-button>
          </b-card>
        </b-col>
        <b-col lg="12" :xl="thumbnail_size == '100%' ? 5 : 12">
          <b-card>
            <div slot="header" class="text-center">
              <strong>スクリーンショット</strong>
            </div>
            <b-row class="text-center">
              <b-col md="12">
                <a @click="toggle_thumbnail" >
                  <img :src="image" style="max-width:850px; cursor:pointer;" :style="{ width: thumbnail_size }">
                </a>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12" xl="12">
          <b-card style="max-height: 400px; overflow: auto;">
            <div slot="header">
              <strong>検出</strong>
              <label class="float-right" v-if="model">{{depth}} 深度</label>
            </div>
            <b-row>
              <b-col md="12">
                <pre slot="body" style="max-width: 100%; max-height: 500px; overflow:auto;">
                  <div v-for="(item, index) in model.url_tree" :key="index" :style="{ 'padding-left' : index * 10 + 'px'}">深度 : {{index+1}} ==> {{item}}
                  </div>
                </pre>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="1" xl="12">
          <b-card>
            <div slot="header">
              <strong>HTMLデータ</strong>
              <b-button class="float-right" size="sm" variant="primary" @click="save_rs"> HTMLソースダウンロード </b-button>
              <b-button class="float-right mr-2" size="sm" variant="warning" @click="copy(model.data, 'html source code')"> コピー </b-button>
              <b-button class="btn-add float-right mr-2" size="sm" variant="success" @click="heilith"> 検出されたパターンを選択 </b-button>
            </div>
            <b-row>
              <b-col md="12" id>
                <!-- <img src="img/texteditorline.png"> -->
                <!-- <b-form-textarea
                    style="overflow: auto;"
                    id="data"
                    :rows="50"
                    v-model="model.data"
                    @change="selecting"
                  >
                </b-form-textarea> -->

                <div>
                  <!-- <pre id="data" slot="body" style="width: 3000px; overflow: visible;">{{model.data}}</pre> -->
                  <!-- <text-highlight style="width: 3000px; overflow: visible;" :queries="[this.model.f1code || this.model.ucode]">
                    {{ model.data }}
                  </text-highlight> -->
                  <htmlViewer :type="codes.WMDS_TYPE[model.type]" ref="html_viewer" @line="x => row_id = x" :html="model.data" :search="this.model.f1code || this.model.ucode" effect='text-danger' />
                </div>
                <!-- <button onclick="TLN.append_line_numbers('test')"> 数字を付けてください！ </button>
                <div id="wrapper">
                    <textarea id="test" class="banana-cake"></textarea>
                </div> -->
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-modal title="検出データの削除"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
        この操作は取り消すことができません
      </b-modal>
    </div>
    <!-- load custom -->
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
